import { axios } from '@/lib/axios';
import { useQuery,useMutation } from 'react-query';

import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';

import { Funnel, ProductResponse, ResponseDetails } from '../types/indes';
import { showNotification } from '@/utils/notificationUtils';




export type DTO11 = {
  id: number;
}

export type DTO12 = {
    list: any;
  }

export const getFunnelStages = (
  {  id }: DTO11 
): Promise<DTO12> => {
  return axios.get(`/superAdmin/get-funnel-stages/${id}`);
};


type UseOptionss = {
config?: MutationConfig<typeof getFunnelStages>;
};

export const useGetFunnelStagess= ({ config }: UseOptionss = {}) => {
return useMutation({
  ...config,
  mutationFn: getFunnelStages,
});
};

